<app-shipment-system-simplenav></app-shipment-system-simplenav>

<div class="container">

    <div class="card  mt-3">
        <div class="card-body">

            <h3 i18n>Drivers</h3>

            <p *ngIf="!shipmentDrivers" class="text-center  text-muted  mt-2" i18n>Indlæser ...</p>

            <div *ngIf="shipmentDrivers">

                <p class="mb-3 text-end">
                    <a href="javascript:" (click)="add()" i18n>Add driver</a>
                </p>



            </div>
        </div>
        <table class="table  table-bordered table-striped">
            <thead class="bg-secondary text-white">
            <tr>
                <th i18n>Name</th>
                <th i18n>Branch</th>
                <th i18n>User</th>
                <th style="width: 50px;"></th>
            </tr>
            </thead>

            <tbody>
            <tr *ngFor="let shipmentDriver of shipmentDrivers">
                <td><a routerLink="/shipment-drivers/{{ shipmentDriver.id }}">{{ shipmentDriver.name }}</a></td>
                <td>{{ shipmentDriver.branch }}</td>
                <td><a routerLink="/user/{{ shipmentDriver?.user?.uuid }}">{{ shipmentDriver?.user?.name }}</a>
                </td>
                <td class="text-end">
                    <!--                        <a href="javascript:" (click)="delete(shipmentDriver)">Slet</a>-->
                    &nbsp;<a
                        routerLink="/shipment-drivers/{{ shipmentDriver.id }}">Ret</a>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</div>
